export default __webpack_public_path__ + "static/media/microscope.2226c90e.svg";